module.exports = __webpack_public_path__ + "static/img/banner-fan.27e1469.png";